import { render, staticRenderFns } from "./FileBlock.vue?vue&type=template&id=5356a244"
import script from "./FileBlock.vue?vue&type=script&lang=js"
export * from "./FileBlock.vue?vue&type=script&lang=js"
import style0 from "./FileBlock.vue?vue&type=style&index=0&id=5356a244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports